module.exports = __webpack_public_path__ + "static/media/BANNER_WEB.df4b2904.png";